import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));
const Profile = props => {
  var strGroup = "Quản trị viên"
  // var userStore = JSON.parse(window.sessionStorage.getItem('user_store'));
  // var userSchoolId = JSON.parse(window.sessionStorage.getItem("UserSchoolId")); // only Id
  // var userSchoolInfo = JSON.parse(window.sessionStorage.getItem("UserSchoolInfo")); // only Id
  // var shoolName = window.sessionStorage.getItem("UserSchoolName");
  
  // if(userStore==null)
  // {
  //   window.location.href = "/dang-nhap"
  // } else {
  //   if(userStore.group_id == 6) {
  //     strGroup = "Admin trường"
  //   } else if(userStore.group_id == 8) {
  //     strGroup = "Giáo viên chủ nhiệm"
  //   } else if(userStore.group_id == 9) {
  //     strGroup = "Giáo viên bộ môn"
  //   } else if(userStore.group_id == 7) {
  //     strGroup = "Trưởng khối"
  //   }
  // }
  // if(userSchoolInfo != null && userSchoolInfo.length > 1){
  //   userSchoolInfo.forEach(el => {
  //     if(el.SchoolID == userSchoolId)    {
  //       shoolName = el.SchoolName;
  //     }  
  //   });
  // }

  const { className, ...rest } = props;

  const classes = useStyles();

  const user = {
    name: "",
    avatar: '/images/avatars/account.png',
    bio: "",
    shool: "",
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      {/* <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/account"
      /> */}
      {/* <a href="/account"> */}
      <a href="javascript:void(0)">
          <img
            className={classes.avatar}
            alt="Person"
            src={user.avatar}
          />
        </a>
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user.name}
      </Typography>
      <Typography variant="body2">{user.bio}</Typography>
      <Typography variant="body2">{user.shool}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
